import { z } from 'zod';

export const formSchema = z.object({
  ma_khai_bao: z.string().optional(),
  status: z.string().default('1')
});

export type FormValues = z.infer<typeof formSchema>;

export const initialValues: FormValues = {
  ma_khai_bao: '',
  status: '1'
};
